import SEO_CONFIG from "@/config/seo.config.json";

export default {
  langList: window._langListData || [],
  tg: {
    en_US: "https://t.me/VOOXEnglish",
    zh_CN: "https://t.me/VOOXChinese",
    zh_TW: "https://t.me/VOOXChinese",
    vi_VN: "https://t.me/VOOXVietnam",
    ru_RU: "https://t.me/VOOXRussiangroup",
    ja_JP: "https://t.me/voox_japan",
  },
  x: {
    en_US: "https://x.com/VOOX_Global",
    zh_CN: "https://x.com/VOOX_ZH",
    zh_TW: "https://x.com/VOOX_ZH",
    zh_TC: "https://x.com/VOOX_ZH",
    zh_TW: "https://x.com/VOOX_ZH",
  },
  tiktok: "https://www.tiktok.com/@vooxglobal",
  medium: "https://medium.com/@voox.exchange",
  youtube: "https://www.youtube.com/@VOOXGLOBAL",
  instagram: "https://www.instagram.com/voox_global/",
  linktree: "https://linktr.ee/VOOXGlobal",
  seo: SEO_CONFIG.content,
};
